import '../../styles/Home.scss'
import api from "../../api";
import {useEffect, useState} from "react";
import {HomePageData} from "../types/Page";
import Header from "./Components/Header";
import PageHero from "./Components/PageHero";
import FeaturedSection from "./Components/FeaturedSection";
import homeSun from "../../assets/images/home-sun-cooking-cleaning-health.svg";
import HomePageBlogs from "./Components/HomePageBlogs";
import FooterWithSignup from "./Components/FooterWithSignup";
import AboutUsSection from "./Components/AboutUsSection";
import HomeProducts from "./Components/HomeProducts";
const Home = () => {
    const [homeData, setHomeData] = useState<HomePageData | null>(null);
    async function fetchHome() {
        try {
            const res = await api.get('/v1/home');

            setHomeData(res.data);
        } catch (error) {
            console.error(error);
        }
    }

    console.log(window.innerWidth)
    useEffect(() => {
        fetchHome()
    }, []);

    return (

        <div className="home-page-container">
            <Header />
            {homeData && homeData.page && homeData.page.headers && (<PageHero headers={homeData.page.headers} />)}
            {homeData && homeData.page && homeData.page.feature_cards && (<FeaturedSection featured_cards={homeData.page.feature_cards} background_color={"#FFD100"} background_image={homeSun} card_color={"#5CB3E6"} font_color={"#FFFFFF"} border_color={"#fff"} page="home"/>)}
            {/*  Home Page Products  */}

            {homeData && homeData.products && homeData.products.length > 0 && <HomeProducts products={homeData.products} />}
            {/*  Home Page About Us  */}
            {homeData && homeData.about_us && homeData.different && homeData.why_choose && <AboutUsSection about_us={homeData.about_us} why_choose={homeData.why_choose} different={homeData.different} page="home"/>}

            {/*  Home Page Blogs  */}
            {homeData && homeData.blogs && homeData.blogs.length > 0 && (<HomePageBlogs blogs={homeData.blogs} />)}

            {/*/!*  Footer With Signup & Map / Contact  *!/*/}
            <FooterWithSignup />
        </div>
    )
}

export default Home;

